import React, { useEffect, useState } from "react";
import { Col, DatePicker, Modal, Row, Select } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import InputText from "../../Input/InputText";
import "../../../../assets/style/modalStyle/addSurvey.scss";
import { useDispatch, useSelector } from "react-redux";

import EnterContent from "../../QuestionSurvey/EnterContent";
import {
  dealSelector,
  pupSelector,
  surveySelector,
} from "../../../../services/selector/index.";
import {
  deleteQuestion,
  editSurvey,
  getDetailSurvey,
  setOpenEditSurvey,
  setOpenNotifySurvey,
} from "../../../../services/slice/SurveySlice";
import { IconEdit, IconUpLoad } from "../../../../assets/icon";
import LabelInput from "../../LabelInput";
import SelectValue from "../../Selector/SelectValue";
import ButtonSelectQuestion from "../../Button/ButtonSelectQuestion";
import StarRate from "../../QuestionSurvey/StarRate";
import EmotionRate from "../../QuestionSurvey/EmotionRate";
import moment from "moment";
import SelectAnswer from "../../QuestionSurvey/SelectAnswer";
import ModalDelete from "../delete/ModalDelete";
import { setOpenPUDelete } from "../../../../services/slice/PopUpSlice";
import { Option } from "antd/lib/mentions";
import ModalSelectGroupCustomer from "../other/ModalSelectGroupCustomer";
import { deleteGroupTime } from "../../../../services/slice/DealSlice";
const ModalEditSurvey = ({ title }) => {
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showSelectGroup, setShowSelectGroup] = useState(false);
  const stateSuvery = useSelector(surveySelector);
  const [valueSelectUsed, setValueSelectUsed] = useState([]);
  const [valueSelectValid, setValueSelectValid] = useState([]);
  const [valueSelectExpired, setValueSelectExpired] = useState([]);
  const [valueSelectNumberMachine, setValueSelectNumberMachine] = useState([]);
  const dealState = useSelector(dealSelector);
  const { isOpenModalEditSurvey, idSurvey, detailByID, callBackRequest } =
    stateSuvery;
  const [error, setError] = useState({
    isError: false,
    msg: "",
    typeQuestion: "",
  });
  const [datapost, setDataPost] = useState({
    nameSurvey: "",
    typeSurvey: 1,
    timeStart: "",
    timeEnd: "",
    typeQuestion: "",
  });
  const [typeDelete, setTypeDelete] = useState("");
  const dateFormat = "DD/MM/YYYY";
  useEffect(() => {
    if (detailByID.idSurvey) {
      setDataPost({
        ...detailByID,
        idSurvey: detailByID.idSurvey,
        nameSurvey: detailByID.nameSurvey,
        typeSurvey: detailByID.typeSurvey,
        // timeStart: moment(detailByID.timeStart).format(dateFormat),
        // timeEnd: moment(detailByID.timeEnd).format(dateFormat),
        timeStart: detailByID.timeStart,
        timeEnd: detailByID.timeEnd,
      });
      setListQuestion(
        detailByID.listQuestions?.map((question) => {
          return {
            ...question,
            listAnswer: question.listAnswer?.map((answer, index) => {
              return {
                ...answer,
                index: index + 1,
              };
            }),
          };
        })
      );
    }
  }, [detailByID]);
  const [listQuestion, setListQuestion] = useState([]);
  // chỉnh sửa khảo sát
  const handleSave = (status) => {
    let arrString;
    const formattedTimeStart = moment(datapost.timeStart).format(
      "YYYY-MM-DD 00:00:00"
    );
    const formattedTimeEnd = moment(datapost.timeEnd).format(
      "YYYY-MM-DD 23:59:59"
    );
    if (datapost.attractGroup && datapost.attractGroup.length) {
      arrString = JSON.stringify(datapost.attractGroup);
    } else arrString = null;

    dispatch(
      editSurvey({
        ...datapost,
        status: status,
        listQuestions: listQuestion,
        attractGroup: arrString,
        timeStart: formattedTimeStart,
        timeEnd: formattedTimeEnd,
      })
    );
  };
  const [valueDelete, setValueDelete] = useState("");

  //Lấy dữ liệu cuộc khảo sát theo id
  useEffect(() => {
    dispatch(getDetailSurvey(idSurvey));
  }, []);
  useEffect(() => {
    if (callBackRequest) {
      dispatch(getDetailSurvey(idSurvey));
    }
  }, [callBackRequest]);

  // đóng modal thêm khảo sát
  const handleCancel = () => {
    dispatch(setOpenEditSurvey(false));
  };
  const handleShowModalDelete = (value) => {
    setTypeDelete("question");
    setValueDelete(value);
    dispatch(
      setOpenPUDelete({
        stateOpen: true,
        content: value.nameQuestion,
        id: value.idQuestion,
      })
    );
  };
  //xóa câu hỏi khỏi cuộc khảo sát
  const handleDelete = () => {
    if (dataDelete.id) {
      dispatch(
        deleteQuestion({ idSurvey: idSurvey, idQuestion: dataDelete.id })
      );
      dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
    } else {
      let arr = listQuestion.filter((item) => item.index !== valueDelete.index);
      arr = arr.map((item, indexId) => ({
        ...item,
        index: indexId + 1,
      }));

      dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
      dispatch(
        setOpenNotifySurvey({
          isOpen: true,
          msg: "Xóa câu hỏi thành công",
          type: "success",
        })
      );
      setListQuestion(arr);
      setTypeDelete("");
    }
  };
  //sắp xếp vị trí câu hỏi trong cuộc khảo sát
  const handleSortDown = (value) => {
    let newData = [...listQuestion];
    const itemIndex = newData.findIndex((item) => item.index === value);
    if (itemIndex !== -1 && itemIndex < newData.length - 1) {
      [newData[itemIndex], newData[itemIndex + 1]] = [
        newData[itemIndex + 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setListQuestion(newData);
    }
  };
  useEffect(() => {
    let arrUse = [];
    let arrValid = [];
    let arrExpired = [];
    let arrNumberMachine = [];
    if (datapost?.attractGroupDetail?.length) {
      datapost?.attractGroupDetail.map((item) => {
        if (item.typeGroup === 1) {
          arrUse.push(item.id);
        } else if (item.typeGroup === 2) {
          arrValid.push(item.id);
        } else if (item.typeGroup === 3) {
          arrExpired.push(item.id);
        } else arrNumberMachine.push(item.id);
        setValueSelectExpired(arrExpired);
        setValueSelectNumberMachine(arrNumberMachine);
        setValueSelectUsed(arrUse);
        setValueSelectValid(arrValid);
      });
    }
  }, [datapost.attractGroup?.length, dealState.dataGroupTime?.length]);

  const handleSortUp = (value) => {
    let newData = [...listQuestion];
    const itemIndex = newData.findIndex((item) => item.index === value);
    if (itemIndex > 0) {
      [newData[itemIndex], newData[itemIndex - 1]] = [
        newData[itemIndex - 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setListQuestion(newData);
    }
  };
  const handleDeleteTimeGroup = () => {
    dispatch(deleteGroupTime(dataDelete.id));
    dispatch(
      setOpenPUDelete({
        stateOpen: false,
        content: "",
        id: "",
      })
    );
  };
  return (
    <>
      {" "}
      {showSelectGroup ? (
        <ModalSelectGroupCustomer
          valueSelectExpired={valueSelectExpired}
          valueSelectNumberMachine={valueSelectNumberMachine}
          setValueSelectExpired={setValueSelectExpired}
          setValueSelectNumberMachine={setValueSelectNumberMachine}
          setValueSelectUsed={setValueSelectUsed}
          setValueSelectValid={setValueSelectValid}
          valueSelectUsed={valueSelectUsed}
          valueSelectValid={valueSelectValid}
          setDataPost={setDataPost}
          open={showSelectGroup}
          setOpen={setShowSelectGroup}
        />
      ) : null}
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={
            typeDelete === "question" ? handleDelete : handleDeleteTimeGroup
          }
          textDisable={
            typeDelete === "question"
              ? "Bạn có đồng ý xóa câu hỏi"
              : "Bạn có đồng ý xóa nhóm"
          }
          title={typeDelete === "question" ? "Xóa câu hỏi" : "Xóa nhóm"}
          width={680}
        />
      )}
      <Modal
        maskClosable={false}
        className="wrapperModalAddSurvey"
        title={t(title)}
        centered
        width={1300}
        open={isOpenModalEditSurvey}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Lưu"}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={() => handleSave(1)}
            width={174}
          />,
          <BaseButton
            content={"Đăng khảo sát"}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={() => handleSave(2)}
            width={"174px"}
          />,
        ]}
      >
        <Row>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Tên"} />
          </Col>
          <Col span={21}>
            <InputText
              focus
              text={datapost.nameSurvey}
              setText={(value) =>
                setDataPost({ ...datapost, nameSurvey: value })
              }
              placeholder={"Nhập tên tiêu đề cho cuộc khảo sát"}
              maxLength={155}
              typeInput={`${
                !datapost.nameSurvey && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Mô tả"} />
          </Col>
          <Col span={21}>
            <InputText
              text={datapost.descriptions}
              setText={(value) =>
                setDataPost({ ...datapost, descriptions: value })
              }
              placeholder={"Nhập mô tả cho cuộc khảo sát"}
              maxLength={155}
              typeInput={`${
                !datapost.descriptions && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Loại khảo sát"} />
          </Col>
          <Col span={8}>
            <SelectValue
              defaultValue={"Tất cả"}
              width={229}
              type={"base"}
              value={datapost.typeSurvey}
              handleChange={(value) =>
                setDataPost({ ...datapost, typeSurvey: value })
              }
              optionsValue={[
                { label: "Tất cả", value: 1 },
                { label: "Danh sách ccs", value: 2 },
              ]}
            />
          </Col>
          <>
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
              <LabelInput text={"Đối tượng hiển thị"} />
            </Col>
            <Col span={6}>
              <Select
                className="base"
                style={
                  error.msg === "Nhóm khách hàng nhận ưu đãi không xác định" &&
                  error.isError
                    ? { border: "1px solid red", width: "100%" }
                    : { width: "100%" }
                }
                onClick={() =>
                  datapost.typeSurvey === 2
                    ? dispatch(
                        setOpenNotifySurvey({
                          isOpen: true,
                          msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                          type: "error",
                        })
                      )
                    : null
                }
                disabled={datapost.typeSurvey === 2 ? true : false}
                value={datapost.typePreferential}
                onChange={(value) => {
                  if (value === 0) {
                    // setValueSelectUsed([]);
                    // setValueSelectValid([]);
                    return setDataPost({
                      ...datapost,
                      attractGroup: [],
                      typePreferential: value,
                    });
                  }
                  setDataPost({ ...datapost, typePreferential: value });
                }}
              >
                <Option value={0}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                  >
                    Tất cả
                  </span>
                </Option>
                <Option value={1}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                    // onClick={() => setShowSelectGroup(true)}
                  >
                    KH thuộc đại lý
                  </span>
                </Option>
                <Option value={2}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                    // onClick={() => setShowSelectGroup(true)}
                  >
                    KH Online
                  </span>
                </Option>
              </Select>
            </Col>
          </>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Thời gian diễn ra từ"} />
          </Col>
          <Col span={8}>
            {/* <DatePicker
              // value={datapost.timeStart ? datapost.timeStart : null}
              onChange={(date) =>
                setDataPost({
                  ...datapost,
                  timeStart: moment(date).format("YYYY-MM-DD 00:00:00"),
                })
              }
              format={dateFormat}
            /> */}
            <DatePicker
              value={
                datapost.timeStart
                  ? moment(datapost.timeStart, "YYYY-MM-DD 00:00:00")
                  : null
              }
              onClick={() =>
                datapost.typeSurvey === 2
                  ? dispatch(
                      setOpenNotifySurvey({
                        isOpen: true,
                        msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                        type: "error",
                      })
                    )
                  : null
              }
              disabled={datapost.typeSurvey === 2 ? true : false}
              format={dateFormat}
              style={{ width: "229px" }}
              onChange={(date) => {
                const momentDate = moment(date);
                setDataPost({
                  ...datapost,
                  timeStart: momentDate.format("YYYY-MM-DD 00:00:00"),
                });
              }}
              placeholder="Chọn thời gian"
            />
          </Col>

          <>
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
              <LabelInput text={"Phạm vi hiển thị"} />
            </Col>
            <Col span={6}>
              <Select
                onClick={() =>
                  datapost.typeSurvey === 2
                    ? dispatch(
                        setOpenNotifySurvey({
                          isOpen: true,
                          msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                          type: "error",
                        })
                      )
                    : null
                }
                disabled={datapost.typeSurvey === 2 ? true : false}
                className="base"
                style={
                  error.msg === "Nhóm khách hàng nhận ưu đãi không xác định" &&
                  error.isError
                    ? { border: "1px solid red", width: "100%" }
                    : { width: "100%" }
                }
                defaultValue={0}
                value={datapost.displayRange}
                onChange={(value) => {
                  if (value === 0) {
                    // setValueSelectUsed([]);
                    // setValueSelectValid([]);
                    return setDataPost({
                      ...datapost,
                      attractGroup: [],
                      displayRange: value,
                    });
                  } else {
                    setShowSelectGroup(true);
                    setDataPost({ ...datapost, displayRange: value });
                  }
                }}
              >
                <Option value={0}>
                  <span
                    style={{
                      width: "100%",
                      display: "flex",
                      overflow: "hidden",
                    }}
                    className="labelSelect"
                  >
                    Toàn bộ KH
                  </span>
                </Option>
                <Option value={1}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexGrow: 1,
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        width: "100%",
                        display: "flex",
                        overflow: "hidden",
                      }}
                      className="labelSelect"
                    >
                      Nhóm
                    </span>
                    <IconEdit onClick={() => setShowSelectGroup(true)} />
                  </div>
                </Option>
              </Select>
            </Col>
          </>
        </Row>
        <Row style={{ margin: "1.5rem 0", height: "58px" }}>
          <Col
            span={3}
            style={{ display: "flex", alignItems: "center", height: "34px" }}
          >
            <LabelInput text={"đến"} />
          </Col>
          <Col span={8}>
            <DatePicker
              value={datapost.timeEnd ? moment(datapost.timeEnd) : null}
              onClick={() =>
                datapost.typeSurvey === 2
                  ? dispatch(
                      setOpenNotifySurvey({
                        isOpen: true,
                        msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                        type: "error",
                      })
                    )
                  : null
              }
              disabled={datapost.typeSurvey === 2 ? true : false}
              format={dateFormat}
              onChange={(date) =>
                setDataPost({
                  ...datapost,
                  timeEnd: moment(date).format("YYYY-MM-DD 23:59:59"),
                })
              }
              style={{ width: "229px" }}
              placeholder="Chọn thời gian"
            />
          </Col>

          <>
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
              <LabelInput text={"Số lượng"} />
            </Col>
            <Col span={6}>
              <InputText
                onClick={() =>
                  datapost.typeSurvey === 2
                    ? dispatch(
                        setOpenNotifySurvey({
                          isOpen: true,
                          msg: "Bạn không thể thực hiện chức năng này khi chọn loại khảo sát Danh sách CCS",
                          type: "error",
                        })
                      )
                    : null
                }
                disable={
                  datapost.typeSurvey === 2 || datapost.displayRange === 0
                    ? true
                    : false
                }
                width="100%"
                typeInput={`${
                  error.msg === "Bạn nhập sai định dạng. Vui lòng nhập lại"
                    ? "checkEmptyText baseInput"
                    : "baseInput"
                }`}
                text={datapost.numberCustomer}
                placeholder="Nhập số lượng KH nhận thông báo"
                setText={(value) =>
                  setDataPost({ ...datapost, numberCustomer: value })
                }
              />
            </Col>
            <Col span={14} />
            <Col span={8} style={{ marginTop: "1rem", fontSize: "11px" }}>
              <i className="note">
                (
                {t(
                  "Nếu không nhập số lượng thì thông báo sẽ gửi cho tất cả khách hàng trong nhóm"
                )}
                )
              </i>
            </Col>
          </>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>{/* <LabelInput text={"Link đặt mua"} /> */}</Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}>
            <LabelInput text={"Thêm câu hỏi"} />
          </Col>
          <Col span={20} className="wrapperButton">
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    typeQuestion: 1,
                    nameQuestion: "",
                    required: 0,
                    listAnswer: [
                      {
                        index: 1,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 2,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 3,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 4,
                        content: "",
                        typeAnswers: 0,
                      },
                    ],
                  },
                ]);
              }}
              width={150}
              backgroundColor={"rgba(97, 181, 255, 0.8)"}
              content={"Radio(chọn 1)"}
            />
            <ButtonSelectQuestion
              width={200}
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    typeQuestion: 1,
                    nameQuestion: "",
                    required: 0,
                    listAnswer: [
                      {
                        index: 1,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 2,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 3,
                        content: "",
                        typeAnswers: 0,
                      },
                      {
                        index: 4,
                        content: "",
                        typeAnswers: 0,
                      },
                    ],
                  },
                ]);
              }}
              backgroundColor={"rgba(84, 190, 0, 0.5)"}
              content={"Checkbox (Chọn nhiều)"}
            />
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  {
                    index: pre.length + 1,
                    typeQuestion: 3,
                    nameQuestion: "",
                  },
                ]);
              }}
              backgroundColor={"rgba(255, 185, 154, 1)"}
              content={"Xếp hạng"}
            />
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  { index: pre.length + 1, typeQuestion: 4, nameQuestion: "" },
                ]);
              }}
              backgroundColor={"rgba(255, 220, 97, 0.5)"}
              content={"Mức độ hài lòng"}
            />
            <ButtonSelectQuestion
              handleClick={() => {
                setListQuestion((pre) => [
                  ...pre,
                  { index: pre.length + 1, typeQuestion: 5, nameQuestion: "" },
                ]);
              }}
              backgroundColor={"rgba(249, 50, 87, 0.5)"}
              content={"Nhập nội dung"}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "1.5rem" }}>
          <Col span={3} style={{ display: "flex", alignItems: "center" }}></Col>
          <Col span={3}>
            <div className="hdQS">Thứ tự</div>
          </Col>
          <Col span={6}>
            <div className="hdQS">Câu hỏi</div>
          </Col>
          <Col span={7}>
            <div className="hdQS">Phương án</div>
          </Col>
          <Col span={2}>
            <div className="hdQS">Bắt buộc</div>
          </Col>
          <Col span={3}>
            <div className="hdQS">Chức năng</div>
          </Col>
        </Row>
        <div className="wrapperQuestions">
          {listQuestion.map((item) => {
            if (item.typeQuestion === 1) {
              return (
                <SelectAnswer
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSave={handleSave}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleShowModalDelete}
                  index={item.index}
                  typeAnswer={"radio"}
                  valueEdit={item}
                />
              );
            }
            if (item.typeQuestion === 2) {
              return (
                <SelectAnswer
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSave={handleSave}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleShowModalDelete}
                  index={item.index}
                  typeAnswer={"checkBox"}
                  valueEdit={item}
                />
              );
            }
            if (item.typeQuestion === 3) {
              return (
                <StarRate
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleShowModalDelete}
                  index={item.index}
                  valueEdit={item}
                />
              );
            }
            if (item.typeQuestion === 4) {
              return (
                <EmotionRate
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleShowModalDelete}
                  index={item.index}
                  valueEdit={item}
                />
              );
            }
            if (item.typeQuestion === 5) {
              return (
                <EnterContent
                  listQS={listQuestion}
                  setListQS={setListQuestion}
                  handleSortUp={handleSortUp}
                  handleSortDown={handleSortDown}
                  handleDelete={handleShowModalDelete}
                  index={item.index}
                  valueEdit={item}
                />
              );
            }
          })}
        </div>
        <Row justify={"end"} style={{ position: "relative" }}>
          {/* </Col> */}
          {error.isError ? (
            <small className="msgError" style={{ bottom: -50, left: 220 }}>
              {t(error.msg)}
            </small>
          ) : null}
        </Row>
      </Modal>
    </>
  );
};

export default ModalEditSurvey;
